<template lang="html">

  <nav class="nav header-nav">
    <div class="nav-right user-box">
      <div class="nav-item">
        <p class="has-text-right" v-if="me.socialName">
          <strong>{{me.socialName}}</strong>
        </p>
      </div>
      <dropdown>
        <figure class="user-box-avatar">
          <span style="display: inline-block; vertical-align: middle">
            <b>{{me.firstName}} </b><br>
          </span>
          <span class="caret">&#9660;</span>
        </figure>

        <div slot="content">
          <menus>
            <menu-item to="" icon="lock" @click.native="showChangePwdModal = true">Alterar Senha</menu-item>
            <div class="divider"></div>
            <menu-item to="/logout" icon="times">Sair</menu-item>
          </menus>
        </div>
      </dropdown>

    </div>
    <modal
      title="Alterar Senha"
      :width="600"
      :is-show="showChangePwdModal"
      transition="fadeDown"
      cancel-text="Cancelar"
      :ok-loading="isLoading"
      ok-text="Alterar a senha"
      @close="showChangePwdModal=false; clearFields()"
      :on-cancel="clearFields"
      :on-ok="change"
      :show-ok="!$v.$invalid"
    >
        <label class="label">Nova senha:</label>
        <p class="control">
          <input class="input" type="password" v-model="password">
        </p>

        <label class="label">Repita a nova senha:</label>
        <p class="control">
          <input class="input" type="password" v-model="confirm">
        </p>
    </modal>
  </nav>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required, minLength, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'UserMenu',
  data () {
    return {
      showChangePwdModal: false,
      isLoading: false,
      password: null,
      confirm: null
    }
  },
  validations: {
    password: {
      required,
      minLength: minLength(6)
    },
    confirm: {
      sameAsPassword: sameAs('password')
    }
  },
  computed: {
    ...mapGetters(['me'])
  },
  methods: {
    ...mapActions(['changePassword']),
    clearFields () {
      this.password = null
      this.confirm = null
    },
    async change () {
      try {
        this.isLoading = true
        await this.changePassword({ password: this.password })
        this.isLoading = false
        this.showChangePwdModal = false
        this.$notify.open({
          type: 'success',
          content: 'A senha foi alterada com sucesso.',
          duration: 10000
        })
        this.clearFields()
      } catch (error) {
        this.isLoading = false
        this.showChangePwdModal = false
        this.$notify.open({
          type: 'danger',
          content: 'Não foi possível alterar a senha agora.',
          duration: 10000
        })
        this.clearFields()
      }
    }
  }
}
</script>

<style lang="css">
  .user-box .dropdown {
    cursor: pointer;
    padding-top: 10px;
  }
  .user-box .user-box-avatar {
    text-align: right;
  }
  .user-box .user-box-avatar img {
    vertical-align: middle;
  }
  .user-box .user-box-avatar .caret {
    color: #ccc;
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/user-menu-component.vue